var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #67b5fe;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.02,270.41c0,33.01,10.12,65.43,28.71,92.53h118.58c-44.96-7.87-77.65-46.79-77.65-92.53,0-50.96,41.44-93.08,92.3-93.95l6.41-.09v-69.59h-6.59c-89.19,1.05-161.76,74.4-161.76,163.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.68,177.06c44.96,7.88,77.65,46.79,77.65,92.53,0,50.96-41.44,93.08-92.3,93.95l-6.41.09v69.59h6.59c89.19-1.05,161.76-74.4,161.76-163.64,0-33.01-10.12-65.43-28.71-92.53h-118.58Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayok);
export default __webpack_public_path__ + "static/media/payok.0b4dbc9140d2d0612fd3d9527999ee6b.svg";
export { ForwardRef as ReactComponent };